import * as ApiClient from '@/libs/ApiClient';
import type { AxiosResponse } from 'axios';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * 完成補件案件請求參數
 */
export interface ICompleteDocumentCaseParams {
    /** 是否有上傳身分證正面 若有需填寫 身份證發證資訊 */
    hasIDFrontItem: boolean;
    /** 身分證發證日期(年) - 民國年 2-3位數 */
    idCheck_Y: string | null;
    /** 身分證發證日期(月) - 1-2位數 */
    idCheck_M: string | null;
    /** 身分證發證日期(日) - 1-2位數 */
    idCheck_D: string | null;
    /** 身分證發證地點代碼 - 1-5位數 (例如: 10003 代表北市) */
    idCheck_P: string | null;
    /** 身分證領補換類別 - 1:初發, 2:補發, 3:換發 */
    idCheck_T: string | null;
}

/**
 * 完成補件案件回應
 */
export interface ICompleteDocumentCaseResponse {
    /** 回應狀態 */
    status: boolean;
    /** 錯誤代碼 */
    code: number;
    /** 例外訊息 */
    exception: string | null;
    /** 訊息 */
    message: string | null;
    /** 尚有未完成的業務 */
    hasUnfinishedBusiness: boolean;
    /** 未完成業務 別名 清單 */
    unfinishedBusinessList?: Array<string>;
    /** 是否達到moi每日限制 */
    isDailyLimitReached: boolean;
    /** moi 錯誤訊息 */
    moiErrorMsg: string | null;
}

/**
 * DocumentCase - 完成補件案件 API
 *
 * @description 完成補件案件，驗證身分證換補領資訊並完成案件流程
 * @param params 完成案件請求參數
 * @returns Promise<ICompleteDocumentCaseResponse>
 */
export async function CompleteDocumentCase(params: ICompleteDocumentCaseParams): Promise<ICompleteDocumentCaseResponse> {
    const url = RouteUrlList.API_CompleteDocumentCase.path;
    const config = {
        params: {
            showOverlay: ApiClient.paramTypeEnum.true,
            getServiceAlert: ApiClient.paramTypeEnum.true
        }
    };

    return await ApiClient.post(
        url,
        {
            HasIDFrontItem: params.hasIDFrontItem,
            IDCheck_Y: params.idCheck_Y,
            IDCheck_M: params.idCheck_M,
            IDCheck_D: params.idCheck_D,
            IDCheck_P: params.idCheck_P,
            IDCheck_T: params.idCheck_T
        },
        config
    ).then((res: AxiosResponse<ICompleteDocumentCaseResponse>) => {
        return res.data;
    });
}

export default CompleteDocumentCase;
